import { render, staticRenderFns } from "./CoaAdd.vue?vue&type=template&id=06be526c"
import script from "./CoaAdd.vue?vue&type=script&lang=js"
export * from "./CoaAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports